var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_377","data-name":"Group 377","transform":"translate(0.666 0.666)"},[React.createElement("path",{"id":"Path_353","data-name":"Path 353","d":"M17.715,9.357c0,3.7-5.356,12.012-7.493,15.182a1.041,1.041,0,0,1-1.729,0C6.356,21.369,1,13.052,1,9.357a8.357,8.357,0,1,1,16.715,0Z","transform":"translate(-0.666 -0.666)","fill":"none","stroke":"#e43d30","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":0}),React.createElement("circle",{"id":"Ellipse_42","data-name":"Ellipse 42","cx":"3.656","cy":"3.656","r":"3.656","transform":"translate(5.035 5.035)","fill":"none","stroke":"#e43d30","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2","key":1})]));
}

Location.defaultProps = {"width":"18.715","height":"26","viewBox":"0 0 18.715 26"};

module.exports = Location;

Location.default = Location;
